// extracted by mini-css-extract-plugin
module.exports = {"generalMessageModal":"GeneralMessageModal_generalMessageModal__G1V3n","errorList":"GeneralMessageModal_errorList__30oR8"};